const Devices = {
  ceiling_mic: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="M35.7 30.5a5.6 5.7 0 0 0 0 -11.4h-21.4a5.6 5.7 0 0 0 0 11.4z" />
        <path d="M32.5 29.8v-6 m-3 0v6 m-3 0v-6 m-3 0v6 m-3 0v-6 m-3 0v6" strokeWidth="1.5" />
      </g>
    </g>,

  pendant_mic: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="M35.7 32.4a5.6 5.7 0 0 0 0 -11.4h-21.4a5.6 5.7 0 0 0 0 11.4z" />
        <path d="M32.4 31.6v-5.6 m-3 0 v5.6 m-3 0 v-5.6 m-3 0 v5.6 m-3 0v-5.6 m-3 0 v5.6 M24.8 20.2V8.2" strokeWidth="1.5" />
      </g>
    </g>,

  tabletop_mic: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="M20 40.2h10 m-5 -1v-4m8.4 -8.2c-2 9.6 -14.8 9.6 -16.8 0m3 -11.6a5.4 5.4 0 0 1 10.8 0v10a5.4 5.4 0 1 1 -10.8 0v-10z" />
        <path d="M29.4 15h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4" strokeWidth="1.5" />
      </g>
    </g>,

  videobar: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
        <g strokeWidth="1.5">
          <path d="m22.5 22.5 h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z" />
          <circle cx="14" cy="25" r="3.5" />
          <circle cx="36" cy="25" r="3.5" />
        </g>
      </g>
    </g>,

  videobar2800: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
        <g strokeWidth="1.5">
          <path d="m19.5 22.5 h4a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z" />
          <path d="m26.5 22.5 h4a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z" />
          <circle cx="11" cy="25" r="3.5" />
          <circle cx="38" cy="25" r="3.5" />
        </g>
      </g>
    </g>,

  audiobar: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
        <g strokeWidth="1.5">
          <circle cx="14" cy="25" r="3.5" />
          <circle cx="36" cy="25" r="3.5" />
        </g>
      </g>
    </g>,

  bar: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
        <g strokeWidth="1.5">
          <path d="m22.5 22.5 h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z" />
          <circle cx="14" cy="25" r="3.5" />
          <circle cx="36" cy="25" r="3.5" />
        </g>
      </g>
    </g>,

  // CBC ceiling/pendant conference bar (PIG-138): a plain bar body with a single centred
  // port and a short mount stub rising from the bar's top edge — the ceiling-mount cue that
  // distinguishes it from the table/wall `audiobar` (which has two side lenses and no stub).
  ceiling_bar: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
        <g strokeWidth="1.5">
          <path d="M25 19 V9" />
          <circle cx="25" cy="25" r="3" />
        </g>
      </g>
    </g>,

  speaker: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <path d="M26.7 12v25.9l-9.2-7.4h-7.7v-11.2h7.7zm7 2.6a25.3 25.3 0 0 1 0 20.8m-3.4-2.7a22 22 0 0 0 0-15.4m6.7-5.4a29.4 29.4 0 0 1 0 26.2"
        stroke={state.icon_stroke} />
    </g>,
  speakerArrow: ({ state, angle }) =>
    <path d='m0 60l-12-30q12 8 24 0z' stroke={state.border_stroke} fill={state.border_stroke} strokeWidth='1' transform={`rotate(${angle})`} />,

  // Speaker Orientation Icons
  speakerOrientation: ({ state, vertical, start = false, end = false }) =>
    <g stroke={state.icon_stroke} strokeWidth='2' fill={state.icon_fill} transform={`${vertical ? 'rotate(90) translate(0 -50)' : ''}`}>
      <path d={`m25 18 a1 1 0 0 0 0 14 a1 1 0 0 0 0 -14`} fill='none' />
      {((!start && !end) || start) && <path d="m2 25 l14-5q-5 5 0 10" stroke='none' />}
      {((!start && !end) || end) && <path d="m48 25 l-14-5 q5 5 0 10" stroke='none' />}
    </g>,

  aimAuto: ({ state }) => <text x='1' y='32' fill={state.icon_fill} stroke='none' fontFamily="monospace" fontSize="1.4em">AUTO</text>,
  // eslint-disable-next-line
  aimVerticalOut: ({ state }) => <Devices.speakerOrientation state={state} vertical />,
  // eslint-disable-next-line
  aimHorizontalOut: ({ state }) => <Devices.speakerOrientation state={state} />,
  // eslint-disable-next-line
  aimRight: ({ state }) => <Devices.speakerOrientation state={state} end />,
  // eslint-disable-next-line
  aimBottom: ({ state }) => <Devices.speakerOrientation state={state} vertical end />,
  // eslint-disable-next-line
  aimLeft: ({ state }) => <Devices.speakerOrientation state={state} start />,
  // eslint-disable-next-line
  aimTop: ({ state }) => <Devices.speakerOrientation state={state} vertical start />,

  // `innerScale` (default 1) lets the mic glyph stay at the normal icon size while the
  // rounded-square body is scaled up to the ceiling-tile footprint by the caller. It is
  // applied as an inverse scale around the square centre (25, 24), so it cancels the
  // larger outer scale and the round mic stays the same size as the other device icons.
  ceiling_tile_mic: ({ state, center = true, innerScale = 1 }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      {/* Body + glyph centred on the icon anchor (24,24). Body x=0.5 → centre 24 (was 1.5 →
          centre 25, which shifted the tile-scaled square ~1px right of its tile); y centre is
          already 24. The glyph is re-placed at (24 24) to stay centred in the body. */}
      <rect x="0.5" y="0.5" width="47" height="47" rx="1.5" fill="none" stroke="#000" strokeWidth="0.55" />
      <g transform={`translate(24 24) scale(${innerScale}) translate(-25 -24)`}>
        <rect x="10.2" y="9.3" width="29.6" height="29.6" rx="14.8" fill={state.border_fill} stroke={state.icon_stroke} strokeWidth="0.75" vectorEffect="non-scaling-stroke" />
        <path d="M30.6 27.8a3.7 3.7 0 0 0 0 -7.4H19.4a3.7 3.7 0 0 0 0 7.4z" fill="none" stroke={state.icon_stroke} strokeWidth="0.7" />
        <path d="M21.3 20.4v7.4 m1.8 -7.4v7.4 m1.8 -7.4v7.4 m1.9 -7.4v7.4 m1.8 -7.4v7.4" stroke={state.icon_stroke} strokeWidth="0.7" />
      </g>
    </g>,

  expansion_mic: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="M35.7 30.5a5.6 5.7 0 0 0 0 -11.4h-21.4a5.6 5.7 0 0 0 0 11.4z" />
        <path d="M32.5 29.8v-6 m-3 0v6 m-3 0v-6 m-3 0v6 m-3 0v-6 m-3 0v6" strokeWidth="1.5" />
      </g>
    </g>,

  expansion_table_mic: ({ state, center = true }) =>
    <g fill='none' strokeWidth='1' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g fill="none" stroke={state.icon_stroke}>
        <path d="M20 40.2h10 m-5 -1v-4m8.4 -8.2c-2 9.6 -14.8 9.6 -16.8 0m3 -11.6a5.4 5.4 0 0 1 10.8 0v10a5.4 5.4 0 1 1 -10.8 0v-10z" />
        <path d="M29.4 15h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4" strokeWidth="1.5" />
      </g>
    </g>,

  camera: ({ state, center = true }) =>
    <g strokeWidth='1.5' strokeMiterlimit='0' transform={center ? 'translate(-24 -24)' : ''}>
      <rect x="0" y="0" width="50" height="50" fill="transparent" pointerEvents="all" />
      <circle cx="25" cy="25" r="23" fill={state.border_fill} stroke={state.border_stroke} />
      <g stroke={state.icon_stroke} fill="none">
        <path d="m14 16h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-10a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3z" />
        <path d="m30.5 21.5l8-5v16l-8-5v-6z" />
      </g>
    </g>,
};


export default Devices;
